import { render, staticRenderFns } from "./AddDataTool.vue?vue&type=template&id=d58e9046&scoped=true&"
import script from "./AddDataTool.vue?vue&type=script&lang=js&"
export * from "./AddDataTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58e9046",
  null
  
)

export default component.exports